import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface Props {
  className?: string;
}

export function UpdateTermsAndConditionsButton(props: Props) {
  const push = useNavigate();
  const { t } = useTranslation();
  const { className } = props;

  return (
    <div className={className}>
      <Button
        type="primary"
        onClick={() => push(`/admin/terms-and-conditions/edit`)}
      >
        {t('termsAndConditions.update')}
      </Button>
    </div>
  );
}
